<sc-icon
    *ngIf="!(loading || disabled)"
    icon="edit" 
    class="edit-button"></sc-icon>
<sc-icon icon="loading" *ngIf="loading && !disabled" class="loading"></sc-icon>
<sc-tooltip *ngIf="disabled"
    [description]="disabledMessage"
    position="left"
    class="small"
    descriptionClasses="text-left">
    <sc-icon icon="edit" class="edit-button edit-button--disabled"></sc-icon>
</sc-tooltip>
<span class="basic-tooltip">{{ tooltipText }}</span>